// 取材・メディア関連のお問い合わせに添付できる資料。受信側 gas/Code.gs の buildAttachments_ と同じ上限・形式にそろえる。
// Yuichi 2026-10-08「メディアからの問い合わせはファイル添付できるように全サイトやってね」
export const MEDIA_INQUIRY_TYPE = 'media';
export const MAX_ATTACH_FILES = 3;
export const MAX_ATTACH_TOTAL_BYTES = 10 * 1024 * 1024;
export const ATTACH_ACCEPT = '.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.jpg,.jpeg,.png,.heic';
const ALLOWED_EXT = /\.(pdf|docx?|pptx?|xlsx?|jpe?g|png|heic)$/i;

export interface AttachmentPayload {
  name: string;
  mimeType: string;
  data: string; // base64 本体(data URL の接頭辞なし)
}

/** 上限・形式を確かめる。問題があれば日英の文言を返す。 */
export function checkAttachments(files: File[], lang: 'ja' | 'en' = 'ja'): string {
  if (files.length > MAX_ATTACH_FILES) {
    return lang === 'en' ? `You can attach up to ${MAX_ATTACH_FILES} files.` : `添付できるファイルは${MAX_ATTACH_FILES}点までです。`;
  }
  const bad = files.find((f) => !ALLOWED_EXT.test(f.name));
  if (bad) {
    return lang === 'en'
      ? `"${bad.name}" cannot be attached. Please use PDF, Word, PowerPoint, Excel, JPEG, PNG or HEIC.`
      : `「${bad.name}」は添付できない形式です。PDF・Word・PowerPoint・Excel・JPEG・PNG・HEIC でお送りください。`;
  }
  const total = files.reduce((s, f) => s + f.size, 0);
  if (total > MAX_ATTACH_TOTAL_BYTES) {
    return lang === 'en' ? 'Attachments must total 10MB or less.' : '添付ファイルは合計10MBまでです。';
  }
  return '';
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const s = String(reader.result ?? '');
      const i = s.indexOf(',');
      resolve(i >= 0 ? s.slice(i + 1) : s);
    };
    reader.onerror = () => reject(reader.error ?? new Error('file read failed'));
    reader.readAsDataURL(file);
  });
}

export async function filesToPayload(files: File[]): Promise<AttachmentPayload[]> {
  const out: AttachmentPayload[] = [];
  for (const f of files) out.push({ name: f.name, mimeType: f.type || 'application/octet-stream', data: await fileToBase64(f) });
  return out;
}
